import { useRecoilState } from 'recoil';
import { FilteredStacks } from '@/src/store/superstack/jobs/FilterStates';
import { AllStackMinYear, AllStackMaxYear } from '@/src/store/superstack/utils/UtilStates';
import { SSModal, SSModal2 } from '@/src/component/superstack/base/Modal';
import { InputSearchGroup } from '@/src/component/superstack/base/InputSearchGroup';
import { Input } from '@/src/component/superstack/base/Inputs';

import classNames from 'classnames/bind';
import styles from '@/styles/superstack/modals/modal.module.scss';
import m_styles from '@/styles/superstack/modals/m.modal.module.scss';
import boxStyles from '@/styles/superstack/base/Box.module.scss';
import { SSRangeYear, SSRangeMinYear, MSSRangeYear } from '@/src/component/superstack/base/Slider';
import { useState } from 'react';
import { MSSModal } from '@/src/component/superstack/base/MModal';
import { Tabs, BoxTabs } from '@/src/component/superstack/base/Tabs';
import {
  BoxStacksSimple,
  StackItemSimple,
  EmptySelectedStackRangeBox,
  MEmptySelectedStackRangeBox,
  MSelectedStackChips,
} from '@/src/component/superstack/base/Box';

import IconX from '@/asset/superstack/svgs/x.svg';
import ArrowRotateLeft from '@/asset/superstack/svgs/arrow-rotate-left.svg';
import StackImage from '@/src/component/superstack/stacks/StackImage';
import { StackFilterBox } from '@/src/component/superstack/stacks/StackSearchBox';

const cx = classNames.bind(styles);
const mcx = classNames.bind(m_styles);

const stackYearMin = 0;
const stackYearMax = 15;

const StackModal = ({ isModalStackOpen, setIsModalStackOpen, stacks }) => {
  const [filteredStacks, setFilteredStacks] = useRecoilState(FilteredStacks);
  return (
    <SSModal2
      isOpen={isModalStackOpen}
      onClose={() => {
        setIsModalStackOpen(false);
      }}
      onReset={() => setFilteredStacks([])}
      btnSubmitName="적용하기"
      btnResetName={'초기화'}
      hasCloseBtn={false}
      hasResetBtn={true}
      customStyle={{ content: { width: '714px' } }}
      titleL="기술 검색"
      titleR="기술 경력 설정"
      childrenL={
        <div className={cx(['modal-stack-search-box'])}>
          <StackFilterBox
            staticStacks={stacks}
            stacks={filteredStacks}
            setStacks={setFilteredStacks}
            scrollable={true}
            scrollHeight={546}
            withIndexScroll={true}
            withRecoil={true}
          />
        </div>
      }
      childrenR={
        <div className={cx(['modal-stack-range-box'])}>
          <div>
            <AllStackRangeYearWrapper
              filteredStacks={filteredStacks}
              setFilteredStacks={setFilteredStacks}
            />
          </div>
          <div
            className={cx([
              'selected-stack-range-list-wrapper',
              Object.keys(filteredStacks).length > 0 ? '' : 'empty',
            ])}
          >
            {Object.keys(filteredStacks).length > 0 ? (
              <RangeYearWrapper
                filteredStacks={filteredStacks}
                setFilteredStacks={setFilteredStacks}
                stacks={stacks}
              />
            ) : (
              <EmptySelectedStackRangeBox />
            )}
          </div>
        </div>
      }
    />
  );
};

const MStackModal = ({ isModalStackOpen, setIsModalStackOpen, stacks }) => {
  const [filteredStacks, setFilteredStacks] = useRecoilState(FilteredStacks);
  const [tab, setTab] = useState('기술 검색');
  return (
    <>
      <MSSModal
        isOpen={isModalStackOpen}
        onClose={() => {
          setIsModalStackOpen(false);
        }}
        onReset={() => setFilteredStacks([])}
        title={'기술 스택 필터'}
        BottomBoxChildren={
          <MSelectedStackChips
            filteredStacks={filteredStacks}
            setFilteredStacks={setFilteredStacks}
          />
        }
        btnResetName={'초기화'}
        hasCloseBtn={false}
        hasResetBtn={true}
        filteredItems={filteredStacks}
        setFilteredItems={setFilteredStacks}
        tab={tab}
      >
        <BoxTabs
          tabNames={['기술 검색', '기술 경력 설정']}
          activeTabName={tab}
          updateContainer={setTab}
          faint={true}
        />
        <section style={{ marginTop: '12px' }}>
          {tab === '기술 검색' && (
            <StackFilterBox
              staticStacks={stacks}
              stacks={filteredStacks}
              setStacks={setFilteredStacks}
              withRecoil={true}
            />
          )}
          {tab === '기술 경력 설정' && (
            <div className={mcx(['modal-stack-range-box'])}>
              <div>
                <MAllStackRangeYearWrapper
                  filteredStacks={filteredStacks}
                  setFilteredStacks={setFilteredStacks}
                />
              </div>
              <div className={mcx(['selected-stack-range-list-wrapper'])}>
                {Object.keys(filteredStacks).length > 0 ? (
                  <MRangeYearWrapper
                    filteredStacks={filteredStacks}
                    setFilteredStacks={setFilteredStacks}
                    stacks={stacks}
                  />
                ) : (
                  <MEmptySelectedStackRangeBox />
                )}
              </div>
            </div>
          )}
        </section>
      </MSSModal>
    </>
  );
};

const RegisterStackModal = ({
  isModalStackOpen,
  setIsModalStackOpen,
  stacks,
  selectedStacks,
  setSelectedStacks,
}) => {
  return (
    <SSModal2
      isOpen={isModalStackOpen}
      onClose={() => {
        setIsModalStackOpen(false);
      }}
      customStyle={{ content: { width: '714px' }, overlay: { zIndex: '2' } }}
      titleL="기술 검색"
      titleR="기술 경력 설정"
      childrenL={
        <div className={cx(['modal-stack-search-box'])}>
          <StackFilterBox
            staticStacks={stacks}
            stacks={selectedStacks}
            setStacks={setSelectedStacks}
            scrollable={true}
            scrollHeight={546}
            withIndexScroll={true}
          />
        </div>
      }
      childrenR={
        <div className={cx(['modal-stack-range-box'])}>
          <div>
            <AllStackRangeMinYearWrapper
              selectedStacks={selectedStacks}
              setSelectedStacks={setSelectedStacks}
            />
          </div>
          <div
            className={cx([
              'selected-stack-range-list-wrapper',
              Object.keys(selectedStacks).length > 0 ? '' : 'empty',
            ])}
          >
            {Object.keys(selectedStacks).length > 0 ? (
              <RangeMinYearWrapper
                selectedStacks={selectedStacks}
                setSelectedStacks={setSelectedStacks}
              />
            ) : (
              <EmptySelectedStackRangeBox />
            )}
          </div>
        </div>
      }
      btnSubmitName="적용하기"
      hasCloseBtn={false}
    />
  );
};

const MRegisterStackModal = ({
  isModalStackOpen,
  setIsModalStackOpen,
  stacks,
  selectedStacks,
  setSelectedStacks,
}) => {
  const [tab, setTab] = useState('기술 검색');
  return (
    <MSSModal
      isOpen={isModalStackOpen}
      onClose={() => {
        setIsModalStackOpen(false);
      }}
      title={'기술 스택 입력하기'}
      hasCloseBtn={false}
    >
      <Tabs
        tabNames={['기술 검색', '기술 경력 설정']}
        activeTabName={tab}
        updateContainer={setTab}
      />
      {tab == '기술 검색' && (
        <div className={cx(['modal-stack-search-box'])}>
          <InputSearchGroup size={'lg'}>
            <Input placeholder="검색할 기술을 입력해 주세요. 예)Java" />
          </InputSearchGroup>
          <div style={{ marginTop: '8px' }}>
            <ul className={cx(['modal-body-ul'])}>
              {stacks &&
                stacks.map((stack) => {
                  return (
                    <li
                      key={stack.name}
                      onClick={() => {
                        setSelectedStacks((selectedStacks) => {
                          return selectedStacks.concat([
                            {
                              flag: stack.flag,
                              name: stack.name,
                              requiredYear: 0,
                            },
                          ]);
                        });
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {stack.name}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      )}
      {tab == '기술 경력 설정' && (
        <div>
          {selectedStacks && (
            <RangeMinYearWrapper
              selectedStacks={selectedStacks}
              setSelectedStacks={setSelectedStacks}
            />
          )}
        </div>
      )}
    </MSSModal>
  );
};

const RangeYearWrapper = ({ filteredStacks, setFilteredStacks, stacks, minOnly = false }) => {
  const deleteFilteredStack = ({ flag }) => {
    const newFilteredStacks = { ...filteredStacks };
    delete newFilteredStacks[flag];
    setFilteredStacks(newFilteredStacks);
  };
  return Object.keys(filteredStacks).map((flag) => {
    const [minV, maxV] = minOnly ? [filteredStacks[flag], undefined] : filteredStacks[flag];
    return (
      <div key={flag} className={cx(['modal-range-wrapper'])}>
        <div className={cx(['modal-range-wrapper-left'])}>
          <span style={{ flexShrink: 0 }}>
            <StackImage flag={flag} width={20} height={20} layout="fixed" />
          </span>
          <span className={cx('stack-name')}>
            {
              stacks.find((stack) => {
                return stack.flag === flag;
              })?.name
            }
          </span>
        </div>
        <div className={cx(['modal-range-wrapper-right'])}>
          <div
            className={cx(['btn-delete-stack'])}
            onClick={() => {
              deleteFilteredStack({ flag });
            }}
          >
            <IconX fill={'#616161'} />
          </div>
          <div style={{ padding: '0px 16px 0px 8px' }}>
            <SSRangeYear
              min={stackYearMin}
              max={stackYearMax}
              minV={minV}
              maxV={maxV}
              updateContainer={(nextRange) => {
                const newFilteredStacks = { ...filteredStacks };
                newFilteredStacks[flag] = nextRange;
                setFilteredStacks(newFilteredStacks);
              }}
            />
          </div>
        </div>
      </div>
    );
  });
};
const MRangeYearWrapper = ({ filteredStacks, setFilteredStacks, stacks, minOnly = false }) => {
  const deleteFilteredStack = ({ flag }) => {
    const newFilteredStacks = { ...filteredStacks };
    delete newFilteredStacks[flag];
    setFilteredStacks(newFilteredStacks);
  };
  return Object.keys(filteredStacks).map((flag) => {
    const [minV, maxV] = minOnly ? [filteredStacks[flag], undefined] : filteredStacks[flag];
    return (
      <div key={flag} className={mcx(['modal-range-wrapper'])}>
        <div className={mcx(['modal-range-wrapper-left'])}>
          <StackImage flag={flag} width={20} height={20} layout="fixed" />
          {
            stacks.find((stack) => {
              return stack.flag === flag;
            })?.name
          }
        </div>
        <span
          className={mcx(['btn-delete-stack'])}
          onClick={() => {
            deleteFilteredStack({ flag });
          }}
        >
          <IconX width={12} height={12} fill={'#616161'} />
        </span>
        <div className={mcx(['modal-range-wrapper-right'])}>
          <MSSRangeYear
            min={stackYearMin}
            max={stackYearMax}
            minV={minV}
            maxV={maxV}
            updateContainer={(nextRange) => {
              const newFilteredStacks = { ...filteredStacks };
              newFilteredStacks[flag] = nextRange;
              setFilteredStacks(newFilteredStacks);
            }}
          />
        </div>
      </div>
    );
  });
};

const AllStackRangeYearWrapper = ({ filteredStacks, setFilteredStacks }) => {
  const [minV, setMinV] = useRecoilState(AllStackMinYear);
  const [maxV, setMaxV] = useRecoilState(AllStackMaxYear);

  const initStack = () => {
    setFilteredStacks(Object.keys(filteredStacks).filter((stacks) => stacks.indexOf > -1));
    setMinV(stackYearMin);
    setMaxV(stackYearMax);
  };

  const newFilteredStacks = { ...filteredStacks };
  return (
    <div>
      <div className={cx(['modal-range-wrapper', 'modal-range-wrapper-all'])}>
        <div className={cx(['modal-range-wrapper-left', 'modal-range-wrapper-all-left'])}>
          경력 전체 설정
        </div>
        <div className={cx(['init-stack-wrapper'])} onClick={initStack}>
          <span className={cx(['init-stack-icon'])}>
            <ArrowRotateLeft />
          </span>
          <span className={cx(['init-stack-text'])}>초기화</span>
        </div>
        <div className={cx(['modal-range-wrapper-right', 'modal-range-wrapper-all-right'])}>
          <div style={{ padding: '0px 8px' }}>
            <SSRangeYear
              min={stackYearMin}
              max={stackYearMax}
              minV={minV}
              maxV={maxV}
              updateContainer={(nextRange) => {
                setMinV(nextRange[0]);
                setMaxV(nextRange[1]);
                Object.keys(filteredStacks).map((flag) => {
                  newFilteredStacks[flag] = nextRange;
                });
                setFilteredStacks(newFilteredStacks);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const MAllStackRangeYearWrapper = ({ filteredStacks, setFilteredStacks }) => {
  const [minV, setMinV] = useRecoilState(AllStackMinYear);
  const [maxV, setMaxV] = useRecoilState(AllStackMaxYear);

  const initStack = () => {
    setFilteredStacks(Object.keys(filteredStacks).filter((stacks) => stacks.indexOf > -1));
    setMinV(stackYearMin);
    setMaxV(stackYearMax);
  };

  const newFilteredStacks = { ...filteredStacks };
  return (
    <div>
      <div className={mcx(['modal-range-wrapper', 'modal-range-wrapper-all'])}>
        <div className={mcx(['modal-range-wrapper-left', 'modal-range-wrapper-all-left'])}>
          경력 전체 설정
        </div>
        <div className={mcx(['init-stack-wrapper'])} onClick={initStack}>
          <span className={mcx(['init-stack-icon'])}>
            <ArrowRotateLeft style={{ width: '12px', height: '12px' }} />
          </span>
          <span className={mcx(['init-stack-text'])}>초기화</span>
        </div>
        <div className={mcx(['modal-range-wrapper-right', 'modal-range-wrapper-all-right'])}>
          <div style={{ paddingRight: '10px' }}>
            <MSSRangeYear
              min={stackYearMin}
              max={stackYearMax}
              minV={minV}
              maxV={maxV}
              updateContainer={(nextRange) => {
                setMinV(nextRange[0]);
                setMaxV(nextRange[1]);
                Object.keys(filteredStacks).map((flag) => {
                  newFilteredStacks[flag] = nextRange;
                });
                setFilteredStacks(newFilteredStacks);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const RangeMinYearWrapper = ({ selectedStacks, setSelectedStacks }) => {
  const deleteSelectedStack = ({ name }) => {
    setSelectedStacks(selectedStacks.filter((stacks) => stacks.name !== name));
  };
  return selectedStacks.map((stack) => {
    const minV = stack.requiredYear || stackYearMin;
    return (
      <div key={stack.name} className={cx(['modal-range-wrapper'])}>
        <div className={cx(['modal-range-wrapper-left'])}>
          <StackImage flag={stack.flag} width={20} height={20} layout="fixed" />
          {stack.name}
        </div>
        <div className={cx(['modal-range-wrapper-right'])}>
          <div
            style={{
              width: '7.5px',
              height: '7.5px',
              float: 'right',
              cursor: 'pointer',
            }}
            onClick={() => {
              deleteSelectedStack(stack);
            }}
          >
            <IconX fill={'#616161'} />
          </div>
          <div style={{ padding: '0px 16px 0px 8px' }}>
            <SSRangeMinYear
              min={stackYearMin}
              max={stackYearMax}
              minV={minV}
              updateContainer={(nextVal) => {
                const newSelectedStacks = selectedStacks.map((thisStack) => {
                  return thisStack.flag === stack.flag
                    ? { ...thisStack, requiredYear: nextVal }
                    : { ...thisStack };
                });
                setSelectedStacks(newSelectedStacks);
              }}
            />
          </div>
        </div>
      </div>
    );
  });
};

const AllStackRangeMinYearWrapper = ({ selectedStacks, setSelectedStacks }) => {
  const [minV, setMinV] = useRecoilState(AllStackMinYear);
  const initStack = () => {
    setSelectedStacks(selectedStacks.filter((stacks) => stacks.name.indexOf > -1));
    setMinV(stackYearMin);
  };
  return (
    <div>
      <div className={cx(['modal-range-wrapper', 'modal-range-wrapper-all'])}>
        <div className={cx(['modal-range-wrapper-left', 'modal-range-wrapper-all-left'])}>
          경력 전체 설정
        </div>
        <div className={cx(['modal-range-wrapper-right', 'modal-range-wrapper-all-right'])}>
          <SSRangeMinYear
            min={stackYearMin}
            max={stackYearMax}
            minV={minV}
            updateContainer={(nextVal) => {
              const newSelectedStacks = selectedStacks.map((thisStack) => {
                setMinV(nextVal);
                return { ...thisStack, requiredYear: nextVal };
              });
              setSelectedStacks(newSelectedStacks);
            }}
          />
        </div>
        <div className={cx(['init-stack-wrapper'])} onClick={initStack}>
          <span className={cx(['init-stack-icon'])}>
            <ArrowRotateLeft />
          </span>
          <span className={cx(['init-stack-text'])}>초기화</span>
        </div>
      </div>
    </div>
  );
};

const StackModalSimple = ({
  isModalStackOpen,
  setIsModalStackOpen,
  stacks,
  selectedStacks,
  setSelectedStacks,
}) => {
  const selectedStackFlags = selectedStacks.map((stack) => {
    return stack.flag;
  });
  const [searchStack, setSearchStack] = useState('');
  const boxCx = classNames.bind(boxStyles);
  return (
    <SSModal
      isOpen={isModalStackOpen}
      onClose={() => {
        setIsModalStackOpen(false);
      }}
      customStyle={{ content: { width: '714px' } }}
      title="기술 스택 입력하기"
      hasCloseBtn={false}
    >
      <div className={cx(['modal-stack-search-box'])}>
        <InputSearchGroup mode="default" size={'lg'}>
          <Input
            placeholder="검색할 기술을 입력해 주세요. 예)Java"
            value={searchStack}
            onChange={(e) => {
              setSearchStack(e.target.value);
            }}
          />
        </InputSearchGroup>
        <div className={cx('stack-modal')} style={{ marginTop: '8px' }}>
          <ul className={cx(['modal-body-ul', 'scrollable-y'])} style={{ height: '30vh' }}>
            <div className={cx('box-stacks-simple')}>
              <div className={cx('stacks-container')}>
                {stacks &&
                  stacks.map((stack) => {
                    const isSelected = selectedStackFlags.includes(stack.flag);
                    return (
                      <StackItemSimple
                        key={stack.name}
                        flag={stack.flag}
                        name={stack.name}
                        selected={isSelected}
                        searched={searchStack}
                        clickable={true}
                        onClick={() => {
                          let newSelectedStacks = [];
                          if (isSelected) {
                            newSelectedStacks = selectedStacks.filter((selected) => {
                              return selected.flag !== stack.flag;
                            });
                          } else {
                            newSelectedStacks = [
                              ...selectedStacks,
                              { flag: stack.flag, name: stack.name },
                            ];
                          }
                          setSelectedStacks(newSelectedStacks);
                        }}
                      >
                        {stack.name}
                      </StackItemSimple>
                    );
                  })}
              </div>
            </div>
          </ul>
          <div
            style={{
              marginTop: '16px',
              padding: '12px',
              backgroundColor: '#FAFAFA',
              maxHeight: '112px',
              overflowY: 'auto',
            }}
          >
            {Object.keys(selectedStacks).length > 0 ? (
              <BoxStacksSimple stacks={selectedStacks} setStacks={setSelectedStacks} cx={boxCx} />
            ) : (
              <div>기술 스택을 선택해 주세요.</div>
            )}
          </div>
        </div>
      </div>
    </SSModal>
  );
};

const MStackModalSimple = ({
  isModalStackOpen,
  setIsModalStackOpen,
  stacks,
  selectedStacks,
  setSelectedStacks,
}) => {
  const selectedStackFlags = selectedStacks.map((stack) => {
    return stack.flag;
  });
  const [searchStack, setSearchStack] = useState('');
  const boxCx = classNames.bind(boxStyles);
  return (
    <MSSModal
      isOpen={isModalStackOpen}
      onClose={() => {
        setIsModalStackOpen(false);
      }}
      title="기술 스택 입력하기"
      hasCloseBtn={false}
    >
      <div className={cx(['modal-stack-search-box'])}>
        <InputSearchGroup size={'lg'}>
          <Input
            placeholder="검색할 기술을 입력해 주세요. 예)Java"
            value={searchStack}
            onChange={(e) => {
              setSearchStack(e.target.value);
            }}
          />
        </InputSearchGroup>
        <div className={cx('stack-modal')} style={{ marginTop: '8px' }}>
          <ul className={cx(['modal-body-ul', 'scrollable-y'])} style={{ height: '30vh' }}>
            <div className={cx('box-stacks-simple')}>
              <div className={cx('stacks-container')}>
                {stacks &&
                  stacks.map((stack) => {
                    const isSelected = selectedStackFlags.includes(stack.flag);
                    return (
                      <StackItemSimple
                        key={stack.name}
                        flag={stack.flag}
                        name={stack.name}
                        selected={isSelected}
                        searched={searchStack}
                        onClick={() => {
                          let newSelectedStacks = [];
                          if (isSelected) {
                            newSelectedStacks = selectedStacks.filter((selected) => {
                              return selected.flag !== stack.flag;
                            });
                          } else {
                            newSelectedStacks = [
                              ...selectedStacks,
                              { flag: stack.flag, name: stack.name },
                            ];
                          }
                          setSelectedStacks(newSelectedStacks);
                        }}
                      >
                        {stack.name}
                      </StackItemSimple>
                    );
                  })}
              </div>
            </div>
          </ul>
          <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#FAFAFA' }}>
            <BoxStacksSimple stacks={selectedStacks} cx={boxCx} />
          </div>
        </div>
      </div>
    </MSSModal>
  );
};

const StackModalRenewal = ({
  isModalStackOpen,
  setIsModalStackOpen,
  stacks,
  selectedStacks,
  setSelectedStacks,
  isMobile,
}) => {
  const Modal_ = isMobile ? MSSModal : SSModal;
  return (
    <>
      <Modal_
        title={'보유 기술 스택'}
        isOpen={isModalStackOpen}
        onClose={() => {
          setIsModalStackOpen(false);
        }}
        customStyle={{
          overlay: {},
          content: isMobile
            ? {}
            : {
                width: '100%',
                maxWidth: '760px',
                position: 'relative',
                inset: '120px 0 0 0',
              },
        }}
        BottomBoxChildren={
          <MSelectedStackChips
            filteredStacks={selectedStacks}
            setFilteredStacks={setSelectedStacks}
          />
        }
        filteredItems={selectedStacks}
        hasResetBtn={true}
        onReset={() => {
          setSelectedStacks([...selectedStacks.filter((stack) => stack.id)]);
        }}
        hasCloseBtn={false}
        hasHeaderMenu={false}
      >
        <section style={{ marginTop: '12px' }}>
          <StackFilterBox
            staticStacks={stacks}
            stacks={selectedStacks}
            setStacks={setSelectedStacks}
            scrollable={true}
            scrollHeight={isMobile ? null : 546}
            withIndexScroll={!isMobile}
            withRecoil={false}
          />
        </section>
      </Modal_>
    </>
  );
};

export {
  StackModal,
  MStackModal,
  RegisterStackModal,
  MRegisterStackModal,
  StackModalSimple,
  MStackModalSimple,
  StackModalRenewal,
};
